import React from "react";
import { BarChart3 } from "lucide-react";

/**
 * EmptyReportState
 *
 * Shown when a project has no tasks / milestones yet
 * or reports data is not meaningful to display.
 */
export default function EmptyReportState({
  title = "No reports available yet",
  description = "Once you start adding tasks and milestones, your project reports will appear here.",
}) {
  return (
    <div className="rounded-2xl border border-dashed bg-white p-10 text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-indigo-50">
        <BarChart3 className="h-6 w-6 text-indigo-600" />
      </div>

      <h3 className="text-lg font-semibold text-gray-900">
        {title}
      </h3>

      <p className="mt-2 text-sm text-gray-600 max-w-md mx-auto">
        {description}
      </p>

      <div className="mt-6 flex justify-center gap-3">
        <span className="inline-flex items-center rounded-lg border px-3 py-2 text-sm text-gray-500">
          Reports update automatically
        </span>
      </div>
    </div>
  );
}